import { state } from './state';
import { initializeStorage } from './state/storage/sagas';
import { refreshAllPaginations } from './state/pagination/sagas';
import translations from './translations.json';


export * from './state/pagination/actions';
export * from './state/pagination/statuses';
export * from './state/pagination/utils';
export * from './state/storage/actions';
export * from './state/sagas';
export * from './state/types';

export * from './components';

export * from './utils';

export const data = {
    state,

    data: {
        domain: {},
    },

    environment: {
        initializationSagas: [initializeStorage],
        changeLanguageSagas: [refreshAllPaginations],
    },

    user: {
        changeUserRoleSagas: [refreshAllPaginations],
    },

    translations,
};
